/**
 * Created by KryQ on 2017-05-15.
 */
/**/
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Brush, Legend, Tooltip } from 'recharts';
import cx from 'classnames';
import moment from 'moment';

export default class TrapData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            chartLoaded: false,
            csv: null,
            chartData: [{"id":28,"trap_id":"022413","co2":18.9,"speed_max":35.1,"count":22,"voltage":0,"load":0,"temp":0,"amps_avg":0,"cycles":0,"date_commited":"2017-05-15T10:14:31.000Z"}]
        };

        this.updateData = this.updateData.bind(this);
        this.closePanel = this.closePanel.bind(this);
        this.convertToCSV = this.convertToCSV.bind(this);
        this.boxInfo = this.boxInfo.bind(this);
        this.longFormatter = this.longFormatter.bind(this);
        this.shortFormatter = this.shortFormatter.bind(this);
    }

    componentWillReceiveProps (nextProps) {
            if (this.props.visible) {
                this.setState({chartLoaded: false});
                if (nextProps.trapId) this.updateData(nextProps.trapId);
            }
            else {
                this.props.setDataPaneVisibility(true);
                this.setState({chartLoaded: false});
                if (nextProps.trapId) this.updateData(nextProps.trapId);
            }
    }

    updateData(id) {
        fetch(this.props.restIp+'/data/'+id)
            .then(function(response) {
                return response.json()
            }).then(function(json) {
                if(json.length === 0) return;
            this.setState({
                chartLoaded: true,
                chartData: json,
            });
            this.convertToCSV(this.state.chartData)
        }.bind(this)).catch(function(ex) {
            console.log('parsing failed', ex)
        });
    }

    closePanel() {
        this.props.setDataPaneVisibility(false);
    }

    boxInfo(icon, text, value, suffix) {
        icon += " fa fa-3x float-left";
        return(
            <Col xs="4" style={{padding: '5px'}}>
                <div className="infobox">
                    {!this.props.settingsPane && <i className={icon} aria-hidden="true"></i>}
                    <span className="float-left">
                        <h3>{text}</h3>
                        <span>{value} {suffix}</span>
                    </span>
                </div>
            </Col>
        )   
    }

    convertToCSV(objArray) {
        var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        var str = '';

        //ToDo unhack this
        str+= 'co2,humidity,pm10,pm_25,temperature,date_commited,hour%0D%0A';
        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line !== '') line += ',';

                line += array[i][index];
            }

            str += line + '%0D%0A';
        }

        this.setState({csv: str});
    }

    shortFormatter (data, format) {
        //Mon Dec 18 2017 23
        //ddd MMM D YYYY DD
        //console.log(data);
        let date = moment(data, "ddd MMM D YYYY H");
        //console.log(date);
        return date.format("DD/MM/YYYY");
    }

    longFormatter (data, format) {
        //Mon Dec 18 2017 23
        //ddd MMM D YYYY DD
        //console.log(data);
        let date = moment(data, "ddd MMM D YYYY H");
        //console.log(date);
        return date.format("DD/MM/YYYY [godz] HH");
    }

    render() {
        let classes = {
            'hidden': !this.props.visible,
            //'animated zoomInLeft': this.props.visible
        };
        let modal_classes = cx(classes);

        let col = (this.props.settingsPane) ? '8' : '10';
        
        const chart =
            <div>
                <div className='pollution'>PM2,5</div>
                <ResponsiveContainer height={500}>
                    <LineChart data={this.state.chartData} margin={{top: 5, right: 50, left: 10, bottom: 5}}>
                        <XAxis dataKey="date_commited" tickFormatter={this.shortFormatter} minTickGap={20} />
                        <YAxis yAxisId="left" orientation="left" fill="#8884d8"/>
                        <YAxis yAxisId="right" orientation="right" fill="#82ca9d"/>
                        <CartesianGrid strokeDasharray="3 5"/>
                        <Tooltip label="date_commited" labelFormatter={this.longFormatter}/>
                        <Line yAxisId="right" name="PM2,5" type="monotone" dataKey="pm_25" stroke="#d82285" dot={false} />
                        <Brush tickFormatter={this.longFormatter} dataKey="date_commited" startIndex={this.state.chartData.length-24}/>
                    </LineChart>
                </ResponsiveContainer>
                <div className='pollution'>Tempratura</div>
                <ResponsiveContainer height={500}>
                    <LineChart data={this.state.chartData}  margin={{top: 5, right: 50, left: 10, bottom: 5}}>
                        <XAxis dataKey="date_commited" tickFormatter={this.shortFormatter} minTickGap={20} />
                        <YAxis yAxisId="left" orientation="left" fill="#8884d8"/>
                        <YAxis yAxisId="right" orientation="right" fill="#82ca9d"/>
                        <CartesianGrid strokeDasharray="3 5"/>
                        <Tooltip label="date_commited" labelFormatter={this.longFormatter}/>
                        <Line yAxisId="left" name="Temperatura" type="monotone" dataKey="temperature" stroke="#d82285" dot={false} />
                        <Brush tickFormatter={this.longFormatter} dataKey="date_commited" startIndex={this.state.chartData.length-24}/>
                    
                    </LineChart>
                </ResponsiveContainer>
                <div className='pollution'>CO2</div>
                <ResponsiveContainer height={500}>
                    <LineChart data={this.state.chartData} margin={{top: 5, right: 50, left: 10, bottom: 5}}>
                        <XAxis dataKey="date_commited" tickFormatter={this.shortFormatter} minTickGap={20} />
                        <YAxis yAxisId="left" orientation="left" fill="#8884d8"/>
                        <YAxis yAxisId="right" orientation="right" fill="#82ca9d"/>
                        <CartesianGrid strokeDasharray="3 5"/>
                        <Tooltip label="date_commited" labelFormatter={this.longFormatter}/>
                        <Line yAxisId="left" name="CO2" type="monotone" dataKey="co2" stroke="#d82285" dot={false} startIndex={this.state.chartData.length-5000} />
                        <Brush tickFormatter={this.longFormatter} dataKey="date_commited" startIndex={this.state.chartData.length-24}/>
                    
                    </LineChart>
                </ResponsiveContainer>
                <div className='pollution'>PM10</div>
                <ResponsiveContainer height={500}>
                    <LineChart data={this.state.chartData} margin={{top: 5, right: 50, left: 10, bottom: 5}}>
                        <XAxis dataKey="date_commited" tickFormatter={this.shortFormatter} minTickGap={20} />
                        <YAxis yAxisId="left" orientation="left" fill="#8884d8"/>
                        <YAxis yAxisId="right" orientation="right" fill="#82ca9d"/>
                        <CartesianGrid strokeDasharray="3 5"/>
                        <Tooltip label="date_commited" labelFormatter={this.longFormatter}/>
                        <Line yAxisId="left" name="PM10" type="monotone" dataKey="pm_10" stroke="#d82285" dot={false} />
                        <Brush tickFormatter={this.longFormatter} dataKey="date_commited" startIndex={this.state.chartData.length-24}/>
                    
                    </LineChart>
                </ResponsiveContainer>
                <div className='pollution'>Wilgotność</div>
                <ResponsiveContainer height={500}>
                    <LineChart data={this.state.chartData} margin={{top: 5, right: 50, left: 10, bottom: 5}}>
                        <XAxis dataKey="date_commited" tickFormatter={this.shortFormatter} minTickGap={20} />
                        <YAxis yAxisId="left" orientation="left" fill="#8884d8"/>
                        <YAxis yAxisId="right" orientation="right" fill="#82ca9d"/>
                        <CartesianGrid strokeDasharray="3 5"/>
                        <Tooltip label="date_commited" labelFormatter={this.longFormatter}/>
                        <Line yAxisId="left" name="humidity" type="monotone" dataKey="humidity" stroke="#d82285" dot={false} />
                        <Brush tickFormatter={this.longFormatter} dataKey="date_commited" startIndex={this.state.chartData.length-24}/>
                    
                    </LineChart>
                </ResponsiveContainer>
                <Button color="primary" href={"data:text/plain;charset=UTF-8,"+this.state.csv} download={this.props.trapId+".csv"} style={{margin: '5rem'}}>Pobierz dane do pliku CSV</Button>
            </div>;

        return (
            <Col className={modal_classes} id="trap_data" md={col} style={{background: 'rgb(240, 240, 230)', zIndex: 2, paddingBottom: '0px'}}>
                <span className="clearfix">
                    {/* <h2 className="float-left" style={{padding: "10px"}}>Statystyki m. {this.props.trapId}</h2> */}
                    <h2 className="float-left" style={{padding: "10px", textAlign: 'center'}}>Dane za ostatnią godzinę</h2>
                    {/* <button type="button" className="close float-right" onClick={this.closePanel} aria-label="Close" style={{padding: "10px"}}>
                        <span aria-hidden="true">&times;</span>
                    </button> */}
                </span>

                <Row noGutters>
                    {this.boxInfo('',
                        'PM2,5',
                        this.state.chartData[this.state.chartData.length-1].pm_25,
                        'μg/м3')}
                    {this.boxInfo('',
                        'CO2',
                        this.state.chartData[this.state.chartData.length-1].co2,
                        'ppm')}
                    {this.boxInfo('',
                        'PM10',
                        this.state.chartData[this.state.chartData.length-1].pm_10,
                        'μg/м3')}
                        
                </Row>

                {this.state.chartLoaded ? chart : <p><i className="fa fa-cog fa-spin fa-5x fa-fw" style={{margin: '200px', color: "#000"}}></i><span className="sr-only">Loadings...</span></p>}
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TrapData.js